import React from 'react';
import FormInputHelpButton from '../FormInputHelpButton';
import ImageUploader from '../fileUpload/ImageUploader';
import { UploadedImage } from '../CommonTypes';
import './DocumentUploader.scss';
import { useTranslation } from 'react-i18next';

export type DocumentUploaderProps = {
    id: string;
    documentIndex: number;
    documentName: string;
    uploadedDocument: UploadedImage;
    allowUpload?: boolean;
    saveOnUpload?: boolean;
    status?: string;
    success?: boolean;
    helpText?: string;
    onDocumentUploaded: (
        documentIndex: number,
        documentName: string,
        image: UploadedImage,
        documentTypeId?: number
    ) => void;
    onUploadComplete?: () => void;
    documentTypeId?: number;
    displayFilenameAsName?: boolean;
};

const DocumentUploader = ({
    id,
    documentIndex,
    documentName,
    uploadedDocument,
    allowUpload = true,
    saveOnUpload = false,
    status,
    success,
    helpText,
    onDocumentUploaded,
    documentTypeId,
    displayFilenameAsName: displayFileName
}: DocumentUploaderProps): JSX.Element => {
    const { t } = useTranslation();

    const documentDisplayName = displayFileName
        ? uploadedDocument?.filename
        : documentName;

    return (
        <div
            id={id}
            data-testid='document-uploader'
            className='card uploader--card'>
            <div
                className={`card-header-container2${success ? ' success' : ''}`}>
                <div className='card-header header-text'>
                    {documentDisplayName ?? ''}
                    {status && <span className='status'>{status}</span>}
                </div>
                {allowUpload && (
                    <ImageUploader
                        name={`${id}-uploader`}
                        title={t('general.upload_document', {
                            document: documentName
                        })}
                        allowPdf={true}
                        saveOnUpload={saveOnUpload}
                        imagePreview={false}
                        UploadedImage={uploadedDocument}
                        onImageChange={(
                            type,
                            uploadedPath,
                            imageId,
                            image,
                            filename
                        ) =>
                            onDocumentUploaded(
                                documentIndex,
                                documentName,
                                {
                                    type,
                                    uploadedPath,
                                    imageId,
                                    image,
                                    filename
                                },
                                documentTypeId
                            )
                        }
                    />
                )}
                {helpText && (
                    <FormInputHelpButton
                        id={`${id}-help`}
                        label={`${id}-help`}
                        helpText={helpText}
                    />
                )}
            </div>
        </div>
    );
};

export default DocumentUploader;
